import productService from '../../products';
import { hasRoomSlots } from '../common';
import { translate } from '../../L10n';
import { t } from '../../../translations';
import tacHelpers from '../../../state/tac/tacHelpers';
import constants from '../../../settings/constants';
import { DIMENSIONS, ITEMS } from '../../../constants';
import { getMeasurementBySoM } from '../../products/productHandler';
import { config as asConfig } from '../../../scene/boaxel/AdjustableConfig';
import { withLigatures } from '../../../util/measures';

function uprightFilter(slot) {
  return slot.width > constants.DYNAMIC_GRID[constants.DRAG_MODE.FLOAT].x.step;
}

function getDisabledStatus(tac, product, space, rebased) {
  if (productService.isType(product, ITEMS.UPRIGHT)) {
    if (!hasRoomSlots(tac, space, product, uprightFilter)) {
      return translate(t.BALLOON_HINT_NO_PLACE);
    }
  } else {
    const hasOpenConnectionSlot = tacHelpers.hasOpenSlot(tac, product, rebased);

    if (!hasOpenConnectionSlot) {
      if (productService.isType(product, ITEMS.CLOTHES_RAIL)) {
        return translate(t.ALERT_INFORMATION_CLOTHES_RAIL);
      }
      return translate(t.BALLOON_HINT_NO_PLACE);
    }
  }
  return false;
}

function displayColor(product) {
  return productService.isType(product, [
    ITEMS.SHELF,
    ITEMS.METAL_SHELF,
    ITEMS.WIRE_SHELF,
    ITEMS.SHOE_SHELF,
    ITEMS.BASKET,
    ITEMS.DRYING_RACK,
    ITEMS.CLOTHES_RAIL,
  ]);
}

function shouldDisplayProductType(product) {
  return !productService.isUpright(product);
}

function getTableDisplayText(
  article,
  product,
  useMetricMeasures,
  dimension = DIMENSIONS.height
) {
  if (dimension !== DIMENSIONS.height)
    return `${getMeasurementBySoM(useMetricMeasures, product[dimension])} ${
      useMetricMeasures
        ? translate(t.MEASURE_VALUE_CM)
        : translate(t.MEASURE_VALUE_IN)
    }`;

  const { minHeight, maxHeight } = asConfig.legs;
  const minValue = getMeasurementBySoM(
    useMetricMeasures,
    product.height + minHeight
  );
  const maxValue = getMeasurementBySoM(
    useMetricMeasures,
    product.height + maxHeight
  );

  return withLigatures(
    `${minValue}-${maxValue} ${
      useMetricMeasures
        ? translate(t.MEASURE_VALUE_CM)
        : translate(t.MEASURE_VALUE_IN)
    }`
  );
}

export default {
  getDisabledStatus,
  displayColor,
  shouldDisplayProductType,
  getTableDisplayText,
};
